/**
 * Protected Route Component
 * Redirects to login if not authenticated
 */
import React from 'react';
import { Box, Spinner, VStack } from '@chakra-ui/react';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.50"
      >
        <VStack spacing={4}>
          <Spinner size="xl" color="blue.500" thickness="4px" />
        </VStack>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Use window.location.href because /login is in AuthApp (different router)
    window.location.href = '/login';
    return null;
  }

  return <>{children}</>;
}
